// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1ddC6","requiredAsterisk":"Info_requiredAsterisk__d3qp1"};